<template>
	<div class="sertificate">
		<b-row>
			<b-col cols="12" md="6" lg="4" v-for="(item, index) in data.docs" :key="index">
				<div class="sertificate-item position-relative">
					<div class="content d-flex justify-content-start align-items-start">
						<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
							<circle cx="21" cy="21" r="21" fill="white"/>
							<path
								d="M24 13H15V29H27V16H24V13ZM15 11H25L29 15V29C29 29.5304 28.7893 30.0391 28.4142 30.4142C28.0391 30.7893 27.5304 31 27 31H15C14.4696 31 13.9609 30.7893 13.5858 30.4142C13.2107 30.0391 13 29.5304 13 29V13C13 12.4696 13.2107 11.9609 13.5858 11.5858C13.9609 11.2107 14.4696 11 15 11V11ZM17 20H25V22H17V20ZM17 24H25V26H17V24Z"
								fill="#B33031"/>
						</svg>
						<div class="text d-flex flex-column justify-content-center align-items-start">
							<p class="description">{{item.file.description}}</p>
							<p class="name">( открыть файл {{item.file.filesizeStr}}.)</p>
						</div>
				<a :href="item.file.url" class="stretched-link" :download="item.file.name" target="_blank"></a>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		data() {
			return {
				data:{},
			}
		},
		beforeCreate () {
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=docs`,
				{responseType: 'json'}
			).then(({data}) => {
				this.data = JSON.parse(data.addons);
				if (this.data.visible !== 1) {
					this.$emit('hideup')
				}
			})
		},
	}
</script>

<style lang="scss" scoped>
	
	.sertificate {
		background: #FDFDFD;
		box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.07);
		border-radius: 6px;
		padding: 40px;
		padding-bottom: 20px;
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			padding: 0;
			box-shadow: none;
			background: #FFFFFF;
		}
		
		&-item {
			margin-bottom: 25px;
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				margin-bottom: 20px;
			}
			
			.content {
				padding: 15px 10px;
				transition: all 300ms ease-in-out;
				
				&:hover {
					background: #FFFFFF;
					box-shadow: 0px 4px 34px #D8E5EA;
					border-radius: 15px;
					
					svg {
						circle {
							fill: #EBDADA;
						}
					}
					
					.name {
						text-shadow: 0px 0px 8px rgba(179, 48, 49, 0.6);
					}
				}
				
				svg {
					flex-shrink: 0;
					margin-right: 10px;
					margin-top: 5px;
					filter: drop-shadow(0px 0px 4px rgba(0, 114, 161, 0.2));
					
					circle {
						transition: all 0.3s ease-in-out;
					}
				}
				
				.text {
					min-height: 73px;
					
					.description {
						font-size: 14px;
						line-height: 130%;
						color: $mainFontColor;
						margin-bottom: 15px;
					}
					
					.name {
						font-weight: 500;
						font-size: 12px;
						line-height: 140.07%;
						color: $activeColor;
						transition: all 0.3s ease-in-out;
					}
				}
			}
		}
	}

</style>